import {ISyncStorage} from "../interfaces/ISyncStorage";

export const AsyncStorage: ISyncStorage = {
    getItem: (s: string): string | null => localStorage.getItem(s),
    clear: (): void => localStorage.clear(),
    removeItem: (s: string): void => localStorage.removeItem(s),
    setItem: (s: string, v: string): void => localStorage.setItem(s, v),
};
